import { type BridgeCard, fullDeck, sortHand } from './cards.js';
import { seededRandom, shuffled } from './rng.js';
import { BRIDGE_SEATS, type BridgeSeat, clockwiseAfter } from './seats.js';

/**
 * Deal 13 cards to each seat from a seeded shuffle, one card at a time clockwise starting with the seat
 * after the dealer. Each hand comes back in display order. Deterministic: the same `seed` and `dealer`
 * always give the same hands.
 */
export function dealHands(seed: number, dealer: BridgeSeat): Record<BridgeSeat, BridgeCard[]> {
  const deck = shuffled(fullDeck(), seededRandom(seed));
  const order = clockwiseAfter(dealer);
  const hands: Record<BridgeSeat, BridgeCard[]> = { N: [], E: [], S: [], W: [] };
  deck.forEach((card, i) => hands[order[i % 4] as BridgeSeat].push(card));
  for (const seat of BRIDGE_SEATS) hands[seat] = sortHand(hands[seat]);
  return hands;
}
